import { faCloudUploadAlt } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { grey } from '@mui/material/colors'
import { Button, Box, Typography } from '@vapor/material'
import { useTranslation } from 'react-i18next'

const ACCEPTED_FILE_TYPE = 'text/html,message/rfc822,application/pdf,image/png,image/jpeg'
const borderRadiusCard = '0.5rem'
const borderColor = grey[400]

export default function UploadFile({
  onUpload,
  accept = ACCEPTED_FILE_TYPE,
  multiple = true,
  label,
}: {
  onUpload: (files: FileList | null) => void
  accept?: string
  multiple?: boolean
  label?: string
}) {
  const { t } = useTranslation()
  return (
    <Box marginBottom={2}>
      <input id="input-upload-file" hidden type="file" accept={accept} multiple={multiple} onChange={(event) => onUpload(event.target.files)} />
      <Button
        sx={{
          border: `1px dashed ${borderColor}`,
          borderRadius: borderRadiusCard,
          flexDirection: 'column',
          padding: 0,
          height: 'unset!important',
          ':hover, :active, :focus': {
            border: `1px dashed ${borderColor}`,
            borderRadius: borderRadiusCard,
            backgroundColor: 'transparent',
          },
        }}
      >
        <label
          style={{ cursor: 'pointer', padding: '2rem' }}
          htmlFor="input-upload-file"
          // for the drag and drop took from: https://developer.mozilla.org/en-US/docs/Web/API/File_API/Using_files_from_web_applications#selecting_files_using_drag_and_drop
          onDragEnter={(event) => {
            event.stopPropagation()
            event.preventDefault()
          }}
          onDragOver={(event) => {
            event.stopPropagation()
            event.preventDefault()
          }}
          onDrop={(event) => {
            event.stopPropagation()
            event.preventDefault()
            onUpload(event.dataTransfer.files)
          }}
        >
          <FontAwesomeIcon icon={faCloudUploadAlt} size="2xl" />
          <Typography as={'span'} sx={{ marginLeft: 0.5, color: 'black', fontWeight: 400 }}>
            {label ?? t('pms.booking.reservation.tab.attaches.upload.text')}
          </Typography>
        </label>
      </Button>
    </Box>
  )
}
